import $ from 'jquery';
import { Autoplay, EffectFade, Navigation, Pagination, Swiper } from 'swiper';

import { $Elements, Events, Durations } from './constants';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Hero slider - Section Carousel ----------

	$('.hero-slider .section-carousel').each(function () {

		if (!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				slidesPerView: "auto",
				loop: true,
				autoplay: {
					disableOnInteraction: false,
				},
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
				modules: [Autoplay, EffectFade, Navigation],
			});
		}
	});

	// ---------- Speakers-Caroussel----------

	$('.our-speakers-section .section-carousel').each(function () {

		if (!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				slidesPerView: 4.3,
				breakpoints: {
					300: {
						slidesPerView: 2.3,
						spaceBetween: 10,
					},
					640: {
						slidesPerView: 2.3,
						spaceBetween: 10,
					},
					768: {
						slidesPerView: 3.3,
						spaceBetween: 10,
					},
					1024: {
						slidesPerView: 4.3,
						spaceBetween: 20,
					},
				},
				spaceBetween: 20,
				loop: true,
				//centeredSlides: 1,
				observer: true,
				modules: [Navigation],
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});



	// ---------- Reviews-Caroussel----------

	$('.reviews-section .section-carousel').each(function () {

		if (!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				slidesPerView: 1.2,
				loop: true,
				//centeredSlides: 1,
				observer: true,
				spaceBetween: 30,
				breakpoints: {
					300: {
						slidesPerView: 1.2,
						spaceBetween: 50,
					},
					1024: {
						slidesPerView: 1.2,
						spaceBetween: 30,
					},
				},
				modules: [Navigation, Pagination],
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
			});
		}
	});
});
